import { render, staticRenderFns } from "./ServiceTemplateEditor.vue?vue&type=template&id=4563bf1c"
import script from "./ServiceTemplateEditor.vue?vue&type=script&lang=js"
export * from "./ServiceTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports